function openSearch() {
  jQuery('#wrapper-search').removeClass('hide').addClass('show');
  jQuery('.btn-search-control').html('<i class="fa-solid fa-xmark text-black"></i>').addClass('btn-close-search');
}
function closeSearch() {
  jQuery('#wrapper-search').removeClass('show').addClass('hide');
  jQuery('.btn-search-control').html('<i class="fa-solid fa-magnifying-glass text-black"></i>').removeClass('btn-close-search');
}
function isMobile() {
  return window.innerWidth < 768;
}
jQuery(function() { 
  jQuery(document).on('click', '.btn-search-control', function(event) {
    openSearch();
  });
  jQuery(document).on('click', '.btn-close-search', function(event) {
    closeSearch();
  });
});
document.addEventListener('DOMContentLoaded', function() {
  const placeholders = document.querySelectorAll('.placeholder-wrapper');
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  function revealTitle(placeholder, realTitle, index) {
    const baseDelay = isMobile ? 1000 : 150; // Ritardo base più lungo per dispositivi mobili
    const incrementalDelay = isMobile ? 50 : 10; // Incremento più alto per dispositivi mobili

    setTimeout(() => {
      placeholder.style.display = 'none';
      realTitle.style.display = 'block';
      
      realTitle.style.opacity = '0';
      realTitle.style.transition = 'opacity 0.25s ease-in';
      
      realTitle.offsetHeight; // Forza reflow
      
      realTitle.style.opacity = '1';
    }, baseDelay + (index * incrementalDelay));
  }

  placeholders.forEach((placeholder, index) => {
    const realTitle = placeholder.nextElementSibling;
    if (realTitle && realTitle.classList.contains('real-title')) {
      revealTitle(placeholder, realTitle, index);
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
  const placeholders = document.querySelectorAll('.placeholder-wrapper');
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  function revealContent(placeholder, realContent, index) {
    const baseDelay = isMobile ? 1000 : 150; // Ritardo base più lungo per dispositivi mobili
    const incrementalDelay = isMobile ? 50 : 10; // Incremento più alto per dispositivi mobili

    setTimeout(() => {
      placeholder.style.display = 'none';
      realContent.style.display = 'block';
      
      realContent.style.opacity = '0';
      realContent.style.transition = 'opacity 0.25s ease-in';
      
      // Forziamo un reflow prima di cambiare l'opacità
      realContent.offsetHeight;
      
      realContent.style.opacity = '1';
    }, baseDelay + (index * incrementalDelay));
  }

  placeholders.forEach((placeholder, index) => {
    const realContent = placeholder.nextElementSibling;
    if (realContent && realContent.classList.contains('real-content')) {
      revealContent(placeholder, realContent, index);
    }
  });
});